<template>
    <div class="stock">

        <van-field :label="$t('message.assetNum')" v-model="assetObj.asset_num" :disabled="true"   
             />
        <van-field v-model="assetObj.serial" :label="$t('message.serial')" :disabled="true"
             />
        <van-field v-model="assetObj.model" :label="$t('message.model')" :disabled="true"
             />
        
        <van-field v-model="assetObj.bu" :label="$t('message.bu')" :disabled="true"  />
        <van-field v-model="assetObj.phone" :label="$t('message.phone')" :disabled="true"/>
        <van-field v-model="assetObj.user_name" :label="$t('message.user_name')" required />
        
        <van-field v-model="assetObj.mobile" :label="$t('message.mobile_company')" required/>
        <!-- <van-field
              v-model="assetObj.sign_time"
              :label="$t('message.sign_time')"
              disabled
            /> -->
        <!-- <van-cell :title="$t('message.sign_time')" :value="assetObj.sign_time" @click="show = true" required /> -->
        <van-calendar v-model="show" @confirm="onConfirm" />
        <van-field v-model="assetObj.n_name" :label="$t('message.n_name')" />

        <van-divider content-position="left">{{ $t('message.photoTip1') }}</van-divider>

        <ChooseImg class="stock-img" @finish="photo1" ref="chooseImg1"/>

        <!-- <van-divider content-position="left">{{$t('message.photoTip2')}}</van-divider>
  
      <ChooseImg class="stock-img" @finish="photo2" ref="chooseImg2" /> -->

        <!-- <van-switch-cell v-model="assetObj.question" :title="$t('message.question')" /> -->


        <van-field v-model="assetObj.sign_notes" clearable :placeholder="$t('message.remarksTip')"
            :label="$t('message.remarks')" type="textarea" maxlength="200" autosize show-word-limit required/>

        <div class="stock-submit">
            <van-button round type="primary" :loading="submitting" :loading-text="$t('message.submitTip')"
                @click="onSubmit"> {{ $t('message.submit') }} </van-button>
        </div>

    </div>
</template>
  
<script>
import {
    Button,
    Image,
    Field,
    Icon,
    Cell,
    CellGroup,
    Divider,
    SwitchCell,
    Toast,
    Dialog,
    NoticeBar,
    Calendar
} from 'vant';
import { jsConfig } from '@/api/wx';
import ChooseImg from '@/components/chooseImg';
import ScanQR from '@/components/scanQR';
export default {
    components: {
        ScanQR,
        ChooseImg,
        [Button.name]: Button,
        [Image.name]: Image,
        [Field.name]: Field,
        [Icon.name]: Icon,
        [CellGroup.name]: CellGroup,
        [Cell.name]: Cell,
        [Divider.name]: Divider,
        [SwitchCell.name]: SwitchCell,
        Toast,
        Dialog,
        [NoticeBar.name]: NoticeBar,
        [Calendar.name]: Calendar
    },

    data() {
        return {
            assetOld: {},
            assetObj: {},
            loading: false,
            img1: '',
            img2: '',
            stockType: '',
            address: '',
            submitting: false,
            show: false,
            listType: 'mine'
        };
    },
    computed: {
        
    },
    methods: {
        isEmptyValue(variable) {
            let aa = variable === null ||
                variable === undefined ||
                variable === ''
            return !aa
        },
        formatDate(date) {
            return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
        },
        onConfirm(date) {
            this.show = false;
            this.assetObj.sign_time = this.formatDate(date);
        },
        onScan(val) {
            this.stockType = 'qrcode';
            this.getAsset('qrcode', val)
        },
        onInput(val) {
            this.stockType = 'input';
            this.getAsset('asset_num', val)
        },
        getAsset(id, type) {
            this.$refs.chooseImg1.refresh()
            this.$axios.get('onlineSign/get?type=' + type + '&id=' + id).then(res => {
                this.assetObj = res
                this.assetOld = {
                    asset_num: res.asset_num,
                    serial: res.serial,
                    model: res.model,
                    mobile: res.mobile,
                    bu: res.bu,
                    user_name: res.user_name,
                    // remarksTip: res.remarksTip,
                    sign_notes:res.sign_notes
                    // photoTip1: res.photoTip1,
                    // sign_file: res.sign_file
                    // sign_time: res.sign_time
                }
            })
        },
        photo1(id) {
            this.img1 = id;
        },
        photo2(id) {
            this.img2 = id;
        },
        onSubmit() {
            // if (!this.assetObj.id) {
            //     Toast('请输入需要盘点的资产');
            //     return;
            // }
            let that = this
            let changeFields = Object.keys(this.assetOld).filter(item => {
                if (!that.assetObj[item]) {
                    return item
                }
            })
            let dataArr = [ 'asset_num',
                    'serial',
                    'model',
                    'bu']
                    dataArr.map((item) => {
                        if(changeFields.indexOf(item) > -1) {
                            let index = changeFields.indexOf(item)
                            changeFields.splice(index, 1)
                        }
                    })
            const stock_question = (changeFields.length > 0) ? 1 : 0

            if (stock_question) {
                Toast('请输入必填字段');
                return;
            }
            if(!this.img1) {
                Toast('请上传照片');
                return;
            }
            this.submitting = true;

            this.assetObj.sign_file = this.img1
            this.$axios.post('onlineSign/sign', this.assetObj).then((number) => {
                //   const message = '当前资产已完成盘点，盘点信息可以在"盘点记录"查看；\n' + (number>0 ? `您当前还有${number}个资产未盘点，请继续` : '');
                Dialog({
                    title: '提交成功'
                })
                this.submitting = false;
                this.assetObj = {},
                    this.loading = false,
                    this.img1 = '',
                    this.img2 = '',
                    this.stockType = ''
                this.$refs.chooseImg1.refresh()
            }).catch(res => {
                Dialog({ message: '盘点失败\n' + res })
                this.submitting = false;
            })
        }
    },

    created() {
        let { id, type } = this.$route.query;
        if (id && type) {
            this.$nextTick(() => {
                this.stockType = "list";
                this.getAsset(id, type);
            })
        }
        this.$wx.ready(() => {
            this.$wx.getLocation({
                type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入"gcj02"
                success: (res) => {
                    this.$axios.get('wx/location?lat=' + res.latitude + '&lng=' + res.longitude)
                        .then(addr => {
                            Toast(addr ? '定位：' + addr : '定位异常');
                            this.address = addr;
                        })

                },
                fail() {
                    Toast('定位失败');
                }
            });
        });
        jsConfig();
    }
};
</script>
  
<style lang="less">
.stock {
    padding: 20px 0 50px 0;

    &-assetDetail {
        padding: 10px 20px;
    }

    &-img {
        margin-left: 20px;
    }

    &-submit {
        text-align: center;

        button {
            padding: 0 50px;
            margin: 20px auto;
        }
    }

}
</style>
  